<template>
	<div class="resultSteps">
		<yayi-steps :current="current" label-placement="vertical">
			<yayi-step v-for="item in tips" :key="item.text" :index="item.index">
				<div class="flex ">
					<SvgIcon class="" size="16" :name="item.icon" />&nbsp;{{ item.text }}
					<stageIcon v-if="item['type'] === 'list' && searchEngineType != 0" :key="item['type'] + id" :dataList="searchEngineList"></stageIcon>
				</div>
				<template #description>
					<stepsList :key="item['type'] + id" :dataList="stagesList[item['type']] || []"></stepsList>
				</template>
			</yayi-step>
		</yayi-steps>
	</div>
</template>
<script setup lang="ts">
import { computed, defineAsyncComponent, onMounted, ref, watch,onUnmounted } from 'vue';
import {useI18n} from "vue-i18n";
import { useSearchState } from '/@/stores/search';

import yayiSteps from './steps/steps.vue';
import yayiStep from './steps/step.vue';
import stepsList from './stepsList.vue';
import stageIcon from './stageIcon.vue';
const { t } = useI18n();
interface Props {
	text?: string;
	stages?: [];
	source?: string;
	loading?: boolean;
	width?: number;
	modelVersion?: string;
	answerFinish?: boolean;
	from?: string;
	id?: string;
	searchEngineList?: [];
	searchEngineType?: number
}

const searchState = useSearchState();

const props = defineProps<Props>();
// const current = ref(0);
const current = computed(() => {
	const lastStage = newStages.value[newStages.value.length - 1];
	const { type = 'null' } = lastStage;
	if (type === 'smart') {
		return 1;
	} else if (type === 'list') {
		return 2;
	} else if (type === 'text') {
		return 3;
	} else if (type === 'stagesInit') {
		return 0;
	} else {
		return 0;
	}
});
const stagesList = computed(() => {
	const stagesList_ = mergeListTypes(newStages);
	return stagesList_;
});
const newStages = computed(() => {
	const stages = props.stages ? searchState.removeDuplicateStages(props.stages) : [[]];
	return stages;
});

const mergeListTypes = (data: any) => {
	let result: any = {};

	try {
		data.value.forEach((item: any) => {
			const { type, list } = item;
			if (!result[type]) {
				result[type] = [];
			}
			if (list) {
				result[type] = result[type].concat(list);
			}
		});
	} catch (error) {}

	return result;
};
const tips = [
	{
		text: t('chat.center.stageSteps1'),
		type: 'smart',
		icon: 'cool-wentijiexi',
		index: 1,
	},
	{
		text: t('chat.center.stageSteps2'),
		type: 'list',
		icon: 'cool-ziliaojiansuo',
		index: 2,
	},
	{
		text: t('chat.center.stageSteps3'),
		type: 'text',
		icon: 'cool-zongjie',
		index: 3,
	},
];

onMounted(() => {
	// setInterval(() => {
	//     current.value++
	// }, 4000);
});
onUnmounted(() => {
	// debugger;
})

const progress = ref(10); // 进度值
</script>
<style lang="scss" scoped>
.resultSteps {
	overflow: hidden;
	// min-width: 800px;
	// width: 100%;
	margin: 14px;
}
</style>